// extracted by mini-css-extract-plugin
module.exports = {"returnToSearch":"_1iWgyOMpp9eOZmq09-u_Hz"};